module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Oberwil_BL-2af0aea169bf38bf072030741ce794b3.svg";